export default [
  {
    label: "通用图标",
    list: [
      "iconfont iconicon_roundadd",
      "iconfont iconicon_compile",
      "iconfont iconicon_glass",
      "iconfont iconicon_roundclose",
      "iconfont iconicon_roundreduce",
      "iconfont iconicon_delete",
      "iconfont iconicon_shakehands",
      "iconfont iconicon_task_done",
      "iconfont iconicon_voipphone",
      "iconfont iconicon_safety",
      "iconfont iconicon_work",
      "iconfont iconicon_study",
      "iconfont iconicon_task",
      "iconfont iconicon_subordinate",
      "iconfont iconicon_star",
      "iconfont iconicon_setting",
      "iconfont iconicon_sms",
      "iconfont iconicon_share",
      "iconfont iconicon_secret",
      "iconfont iconicon_scan_namecard",
      "iconfont iconicon_principal",
      "iconfont iconicon_group",
      "iconfont iconicon_send",
      "iconfont iconicon_scan",
      "iconfont iconicon_search",
      "iconfont iconicon_refresh",
      "iconfont iconicon_savememo",
      "iconfont iconicon_QRcode",
      "iconfont iconicon_im_keyboard",
      "iconfont iconicon_redpacket",
      "iconfont iconicon_photo",
      "iconfont iconicon_qq",
      "iconfont iconicon_wechat",
      "iconfont iconicon_phone",
      "iconfont iconicon_namecard",
      "iconfont iconicon_notice",
      "iconfont iconicon_next_arrow",
      "iconfont iconicon_left",
      "iconfont iconicon_more",
      "iconfont iconicon_details",
      "iconfont iconicon_message",
      "iconfont iconicon_mobilephone",
      "iconfont iconicon_im_voice",
      "iconfont iconicon_GPS",
      "iconfont iconicon_ding",
      "iconfont iconicon_exchange",
      "iconfont iconicon_cspace",
      "iconfont iconicon_doc",
      "iconfont iconicon_dispose",
      "iconfont iconicon_discovery",
      "iconfont iconicon_community_line",
      "iconfont iconicon_cloud_history",
      "iconfont iconicon_coinpurse_line",
      "iconfont iconicon_airplay",
      "iconfont iconicon_at",
      "iconfont iconicon_addressbook",
      "iconfont iconicon_boss",
      "iconfont iconicon_addperson",
      "iconfont iconicon_affiliations_li",
      "iconfont iconicon_addmessage",
      "iconfont iconicon_addresslist",
      "iconfont iconicon_add",
      "iconfont icongithub",
      "iconfont icongitee2",
    ]
  },
  {
    label: "系统图标",
    list: [
      "iconfont icon-zhongyingwen",
      "iconfont icon-caidan",
      "iconfont icon-rizhi1",
      "iconfont icon-zhuti",
      "iconfont icon-suoping",
      "iconfont icon-bug",
      "iconfont icon-qq1",
      "iconfont icon-weixin1",
      "iconfont icon-shouji",
      "iconfont icon-mima",
      "iconfont icon-yonghu",
      "iconfont icon-yanzhengma",
      "iconfont icon-canshu",
      "iconfont icon-dongtai",
      "iconfont icon-iconset0265",
      "iconfont icon-shujuzhanshi2",
      "iconfont icon-tuichuquanping",
      "iconfont icon-rizhi",
      "iconfont icon-cuowutishitubiao",
      "iconfont icon-debug",
      "iconfont icon-iconset0216",
      "iconfont icon-quanxian",
      "iconfont icon-quanxian",
      "iconfont icon-shuaxin",
      "iconfont icon-bofangqi-suoping",
      "iconfont icon-quanping",
      "iconfont icon-navicon",
      "iconfont icon-biaodan",
      "iconfont icon-liuliangyunpingtaitubiao08",
      "iconfont icon-caidanguanli",
      "iconfont icon-cuowu",
      "iconfont icon-wxbgongju",
      "iconfont icon-tuichu",
      "iconfont icon-daohanglanmoshi02",
      "iconfont icon-changyonglogo27",
      "iconfont icon-biaoge",
      "iconfont icon-baidu1",
      "iconfont icon-tubiao",
      "iconfont icon-souhu",
      "iconfont icon-msnui-360",
      "iconfont icon-iframe",
      "iconfont icon-huanyingye",
    ]
  },
  {
    label: "app首页图标",
    list: [
      '#icon-menu-cgjhjjdc',
      '#icon-menu-cgjjmx',
      '#icon-menu-cgpcdgl',
      '#icon-menu-dyhtgl',
      '#icon-menu-kf',
      // '#icon-menu-operation-patrol',
      // '#icon-menu-operation-repair',
      // '#icon-menu-operation-safety-check',
      '#icon-menu-qd',
      '#icon-menu-rzcg',
      '#icon-menu-smdzthd',
      '#icon-menu-thd',
      '#icon-menu-tz',
      '#icon-menu-wdxx',
      '#icon-menu-xsddgl',
      '#icon-menu-xshtgl',
      '#icon-menu-xsjjmx',
      '#icon-menu-xspcgl',
      '#icon-menu-yj',
    ]
  },
  {
    label: "app功能图标",
    list: [
      '#icon-pcs',
      '#icon-zfys',
      '#icon-zfyl',
      '#icon-fbtz',
      '#icon-tz',
      '#icon-clrgsh',
      '#icon-sjrgsh',
      '#icon-xsddjjdc',
      '#icon-xsjjlsmx',
      '#icon-cgddjjdc',
      '#icon-cgjjlsmx',
      '#icon-cghtjjdc',
      '#icon-cgjhjjdc',
      '#icon-cgjjmx',
      '#icon-xsjhjjdc',
      '#icon-xshtjjdc',
      '#icon-xsjjmx',
      '#icon-rzcg',
      '#icon-rzz',
      '#icon-rzsb',
      '#icon-bbgx',
      '#icon-ysxy',
      '#icon-ghsjh',
      '#icon-zhzx',
      '#icon-xgmm',
      '#icon-wdxx',
      '#icon-wdcl',
      '#icon-qr',
      '#icon-sjrz',
      '#icon-thd',
      "#icon-xshtgl",
      "#icon-xspcgl",
      "#icon-xsht",
      "#icon-dypcdgl",
      "#icon-xsjhgl",
      "#icon-cgpcdgl",
      "#icon-dyjhgl",
      "#icon-xsjhgl-1",
      "#icon-dyddgl",
      "#icon-dyhtgl",
      "#icon-xsddgl",
      "#icon-xsddgl-1",
      "#icon-cgdzbd",
      "#icon-dydzbd",
      "#icon-pcgl",
      "#icon-xsdzbd",
      "#icon-wdpd",
      "#icon-yqy",
      "#icon-dtxl",
      "#icon-byxl",
      "#icon-qytxl",
      "#icon-bnxl",
      "#icon-qd",
      "#icon-smdzthd",
      "#icon-gn1",
      "#icon-zs1",
      "#icon-gn",
      "#icon-wd1",
      "#icon-sy1",
      "#icon-wd",
      "#icon-zs",
      "#icon-sy",
      "#icon-sz",
      "#icon-txl",
      "#icon-gzh",
      "#icon-wd-qr",
      "#icon-kf",
      "#icon-yj",
      "#icon-xx",
      "#icon-dk",
      "#icon-electronic-fence-linkage",
      "#icon-multi-level-alert-push",
      "#icon-patrol-workorder-audit",
      "#icon-contract-management",
      "#icon-yard-storage-statistics",
      "#icon-dumper-operation-progress",
      "#icon-emergency-communication",
      "#icon-violation-event-processing",
      "#icon-hazard-fault-report",
      "#icon-equipment-alarm-tracking",
      "#icon-outbound-quota-config",
      "#icon-coal-inventory-ledger",
      "#icon-outbound-statistics",
      "#icon-road-outbound-registration",
      "#icon-dispatch-order-management",
      "#icon-railway-daily-plan-submit",
      "#icon-patrol-point-checkin-record",
      "#icon-patrol-work-order",
      "#icon-electronic-work-order",
      "#icon-create-repair-work-order",
      "#icon-electronic-sign-receipt",
      "#icon-emergency-workorder-audit",
      "#icon-truck-in-daily-plan-audit",
      "#icon-truck-out-daily-plan-audit",
      "#icon-railway-daily-plan-audit",
      "#icon-queue-call-management",
      "#icon-environment-alarm-info",
      "#icon-outbound-dispatch-order",
      "#icon-inbound-dispatch-order",
      "#icon-inbound-contract-management",
      "#icon-inbound-order-management",
      "#icon-inbound-plan-management",
      "#icon-inbound-weigh-detail",
      "#icon-notice-announcement",
      "#icon-outbound-electronic-weigh-bill",
      "#icon-inbound-electronic-weigh-bill",
      "#icon-queue-application",
      "#icon-queue-record",
    ]
  }
]
